import { render, staticRenderFns } from "./ProductEditIntrastatData.vue?vue&type=template&id=416c526c&scoped=true"
import script from "./ProductEditIntrastatData.vue?vue&type=script&lang=ts"
export * from "./ProductEditIntrastatData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416c526c",
  null
  
)

export default component.exports